<ng-container *transloco="let t; prefix:'customers.customersDetail'">
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ t(dialogTitleKey) }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="t('contacts.form.closeAriaLabel')"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content" [formGroup]="addContactForm">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.fullName') }}</mat-label>
            <input matInput formControlName="nomeCognome">
            @if (addContactForm.controls.nomeCognome.hasError('required')) {
                <mat-error>{{ t('contacts.form.fullNameRequired') }}</mat-error>
            } @else if (addContactForm.controls.nomeCognome.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 100 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.phone') }}</mat-label>
            <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="telefono">
            @if (addContactForm.controls.telefono.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 20 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.mobile') }}</mat-label>
            <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="cellulare">
            @if (addContactForm.controls.cellulare.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 20 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.fax') }}</mat-label>
            <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="fax">
            @if (addContactForm.controls.fax.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 20 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.email') }}</mat-label>
            <input matInput formControlName="email">
            @if (addContactForm.controls.email.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 100 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('contacts.form.role') }}</mat-label>
            <input matInput formControlName="ruolo">
            @if (addContactForm.controls.ruolo.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 50 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="text-area-custom">
            <mat-label>{{ t('contacts.form.notes') }}</mat-label>
            <textarea matInput formControlName="note" rows="3"></textarea>
            @if (addContactForm.controls.note.hasError('maxlength')) {
                <mat-error>{{ t('contacts.form.maxLengthError', { max: 500 }) }}</mat-error>
            }
        </mat-form-field>

        <mat-slide-toggle formControlName="default" labelPosition="before">
            {{ t('contacts.mainContact') }}
        </mat-slide-toggle>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onCancel()">{{ t('contacts.form.cancel') }}</button>
        <button matButton="filled" (click)="onSave()">{{ t('contacts.form.save') }}</button>
    </mat-dialog-actions>
</ng-container>
